import { useMemo, useCallback } from "react"
import ExcelJS from 'exceljs'

import { SisetusDpcResult } from "interface/dpc/types"
import { SelectedDpc } from '../types'

export const useDpcResultDownload = () => {
	const doDownload = useCallback(
		async (
			mdcName: string | undefined,
			results: SisetusDpcResult[],
			selectedDpcList: SelectedDpc[],
			calcTotalCase: (result: SisetusDpcResult, dpcCode: string) => number | undefined
		) => {
			const workbook = new ExcelJS.Workbook()
			workbook.addWorksheet('sheet1')
			const worksheet = workbook.getWorksheet('sheet1')
			if (!worksheet) return

			const downloadName = mdcName ?? '施設実績'
			worksheet.columns = [
				{ header: '施設CD', key: 'sisetuCode' },
				{ header: '都道府県', key: 'prefecture' },
				{ header: '施設名', key: 'sisetuName' }
			].concat(
				selectedDpcList.map((dpc, index) => ({
					header: dpc.diseaseName ?? `column-${index}`,
					key: dpc.dpcCode
				}))
			)
			worksheet.addRows(results.map(
				(result) => {
					const filteredCounts = selectedDpcList.reduce<{ [index: string]: number | string }>(
						(acc, dpc) => {
							const value = calcTotalCase(result, dpc.dpcCode)
							acc[dpc.dpcCode] = (value !== undefined) ? value : ''
							return acc
						},
						{}
					)	
					return {
						sisetuCode: result.sisetu.sisetuCode,
						prefecture: result.sisetu.juusyoKenName,
						sisetuName: result.sisetu.sisetuName,
						...filteredCounts,
					}
				}
			))
			const uint8Array = await workbook.xlsx.writeBuffer()
			const blob = new Blob([uint8Array], { type: 'application/octet-binary' })
			const url = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.setAttribute('href', url)
			link.setAttribute('download', `${downloadName}.xlsx`)
			link.style.display = 'none'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
		[]
	)
	return useMemo(() => ({
		doDownload
	}), [
		doDownload
	])
}